document.querySelectorAll('.scrolling-images').forEach((section) => {
  if (section.dataset.manualControlsReady) return;
  section.dataset.manualControlsReady = 'true';

  const track = section.querySelector('.scrolling-images--inner');
  const previousButton = section.querySelector('.scrolling-images--control-prev');
  const nextButton = section.querySelector('.scrolling-images--control-next');
  if (!track || !previousButton || !nextButton) return;

  let resumeTimer;
  const move = (direction) => {
    const firstItem = track.querySelector('.scrolling-images--item');
    const distance = firstItem ? firstItem.getBoundingClientRect().width + 20 : track.clientWidth * 0.75;
    track.classList.add('is-manually-controlled');
    track.scrollBy({ left: direction * distance, behavior: 'smooth' });
    window.clearTimeout(resumeTimer);
    resumeTimer = window.setTimeout(() => track.classList.remove('is-manually-controlled'), 5000);
  };

  previousButton.addEventListener('click', () => move(-1));
  nextButton.addEventListener('click', () => move(1));
});
